import { useState, useEffect } from "react"
import { useApolloClient, useQuery } from "@apollo/client"
import { EledoAccountMember, EledoAccountMembersData, EledoAccountMembersVars, GET_ACCOUNT_MEMBERS } from "graphql/EledoAccountMemberQueries"


function useEledoAccountMembers({limit, page}: EledoAccountMembersVars) {
  const client = useApolloClient()
  const { loading, error, data } = useQuery<EledoAccountMembersData, EledoAccountMembersVars>(GET_ACCOUNT_MEMBERS, {variables:{limit, page}})
  const [members, setEledoAccountMembers] = useState<EledoAccountMember[]>([])
  const [total, setTotal] = useState<number>(0)
  const [membersLoading, setEledoAccountMembersLoading] = useState<boolean>(false)

  useEffect(() => {
    if (loading){
      setEledoAccountMembersLoading(true)
      return
    }

    const _members: EledoAccountMember[] = data?.accountMembers.items.map(log => structuredClone(log)) || []

    setEledoAccountMembers(_members)
    setTotal(data?.accountMembers.total || 0)
    setEledoAccountMembersLoading(loading)
  }, [data, client, loading])

  return { membersLoading, error, members, total }
}


export default useEledoAccountMembers